export default "__VITE_ASSET__B1Icz8V5__"